(() => {
  const installedAccounts = new WeakMap();

  const shellStyles = `
    #shopify-element-wrapper,
    #shopify-element-wrapper > .wrapper,
    .account-button {
      width: var(--pg-account-hit-size, 44px) !important;
      height: var(--pg-account-hit-size, 44px) !important;
      min-width: var(--pg-account-hit-size, 44px) !important;
      min-height: var(--pg-account-hit-size, 44px) !important;
    }

    #shopify-element-wrapper > .wrapper,
    .account-button {
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
    }

    dialog.dialog,
    .account,
    .account__header-region,
    .account__header,
    .account__content {
      background-color: #ffffff !important;
    }

    .account__item-wrapper:has(a.account__item[href$="/account/logout"]),
    .account__item-wrapper:has(a.account__item[href*="/account/logout?"]),
    .account__item-wrapper:has(a.account__item[href$="/customer_identity/logout"]),
    .account__item-wrapper:has(a.account__item[href*="/customer_identity/logout?"]) {
      display: none !important;
    }

    /*
     * Desktop keeps PegGrid's approved outline trigger. Responsive and
     * touch-capable layouts use Shopify's single native identity control.
     */
    .account-button__avatar,
    .account-button__avatar-image,
    .account-button__coin-front,
    .account-button__coin-back,
    slot[name="signed-out-avatar"] {
      opacity: 0 !important;
      visibility: hidden !important;
    }

    @media (max-width: 989px),
      (max-width: 1366px) and (any-pointer: coarse) {
      dialog.dialog,
      .account,
      .account__header-region,
      .account__header,
      .account__content {
        background-color: #ffffff !important;
      }

      dialog.dialog,
      .account {
        border-radius: 0 !important;
      }

      .account-button {
        position: relative !important;
      }

      .account-button__avatar {
        position: absolute !important;
        top: 50% !important;
        left: 50% !important;
        margin: 0 !important;
        transform: translate(-50%, -50%) !important;
      }

      .account-button__avatar,
      .account-button__avatar-image,
      .account-button__coin-front,
      .account-button__coin-back,
      slot[name="signed-out-avatar"] {
        opacity: 1 !important;
        visibility: visible !important;
      }
    }

    /*
     * Reveal only the merchant-configured menu row beneath Help
     * Centre. Shopify's separate native logout action remains
     * hidden, so hydration order cannot expose a duplicate.
     */
    .account:has(.account__login-slot[hidden])
      .account__shortcuts
      .account__item-wrapper:has(a.account__item[href$="/account/logout"]),
    .account:has(.account__login-slot[hidden])
      .account__shortcuts
      .account__item-wrapper:has(a.account__item[href*="/account/logout?"]),
    .account:has(.account__login-slot[hidden])
      .account__shortcuts
      .account__item-wrapper:has(a.account__item[href$="/customer_identity/logout"]),
    .account:has(.account__login-slot[hidden])
      .account__shortcuts
      .account__item-wrapper:has(a.account__item[href*="/customer_identity/logout?"]) {
      display: block !important;
    }

    /*
     * On touch-responsive layouts, Shopify can briefly mark the login region
     * hidden before its authenticated avatar has hydrated. Keep Sign Out
     * suppressed until both native account signals agree.
     */
    @media (max-width: 989px),
      (max-width: 1366px) and (any-pointer: coarse) {
      #shopify-element-wrapper:not(:has(.account-button__avatar))
        .account__shortcuts
        .account__item-wrapper:has(a.account__item[href$="/account/logout"]),
      #shopify-element-wrapper:not(:has(.account-button__avatar))
        .account__shortcuts
        .account__item-wrapper:has(a.account__item[href*="/account/logout?"]),
      #shopify-element-wrapper:not(:has(.account-button__avatar))
        .account__shortcuts
        .account__item-wrapper:has(a.account__item[href$="/customer_identity/logout"]),
      #shopify-element-wrapper:not(:has(.account-button__avatar))
        .account__shortcuts
        .account__item-wrapper:has(a.account__item[href*="/customer_identity/logout?"]) {
        display: none !important;
      }
    }

    @media (min-width: 751px) {
      dialog.dialog {
        top: 0 !important;
        right: 0 !important;
        bottom: auto !important;
        left: auto !important;
        width: min(46rem, 100vw) !important;
        max-width: 100vw !important;
        height: auto !important;
        max-height: 100dvh !important;
        margin: 0 !important;
        border-radius: 0 0 0 var(--shopify-account-radius-dialog);
        animation: none !important;
        transform: translateX(100%);
        transition:
          transform 0.6s cubic-bezier(0.7, 0, 0.2, 1),
          display 0.6s allow-discrete,
          overlay 0.6s allow-discrete;
      }

      dialog.dialog[open] {
        transform: translateX(0);
      }

      dialog.dialog.pg-account-closing {
        transform: translateX(100%);
      }

      @starting-style {
        dialog.dialog[open] {
          transform: translateX(100%);
        }
      }

      .account {
        height: auto !important;
        max-height: 100dvh !important;
      }

      .account__content {
        flex: 0 1 auto !important;
        height: auto !important;
        min-height: 0;
      }
    }

    /*
     * Keep the native tablet interaction pattern while using PegGrid's square,
     * solid-white presentation. Fine-pointer desktop remains unchanged.
     */
    @media (min-width: 751px) and (max-width: 989px),
      (min-width: 751px) and (max-width: 1366px) and (any-pointer: coarse) {
      dialog.dialog {
        top: 20px !important;
        right: 20px !important;
        bottom: auto !important;
        left: auto !important;
        width: min(36rem, calc(100vw - 40px)) !important;
        max-width: calc(100vw - 40px) !important;
        height: auto !important;
        max-height: calc(100dvh - 40px) !important;
        margin: 0 !important;
        background-color: #ffffff !important;
        border-radius: 0 !important;
        opacity: 0;
        overflow: hidden;
        transform: translateY(-12px);
        transition:
          opacity 0.22s ease,
          transform 0.22s cubic-bezier(0.2, 0, 0, 1),
          display 0.22s allow-discrete,
          overlay 0.22s allow-discrete;
      }

      dialog.dialog[open] {
        opacity: 1;
        transform: translateY(0);
      }

      dialog.dialog.pg-account-closing {
        opacity: 0;
        transform: translateY(-12px);
      }

      @starting-style {
        dialog.dialog[open] {
          opacity: 0;
          transform: translateY(-12px);
        }
      }

      .account {
        height: auto !important;
        max-height: calc(100dvh - 40px) !important;
        background-color: #ffffff !important;
        border-radius: 0 !important;
        overflow: hidden;
      }

      .account__content {
        overflow-y: auto;
        overscroll-behavior: contain;
      }
    }

    .account__close {
      width: 40px !important;
      min-width: 40px !important;
      max-width: 40px !important;
      height: 40px !important;
      min-height: 40px !important;
      max-height: 40px !important;
      padding: 0 !important;
      aspect-ratio: 1;
    }

    .account__close svg {
      transition: transform 0.3s cubic-bezier(0.7, 0, 0.2, 1);
    }

    .account__close:active svg,
    dialog.pg-account-closing .account__close svg {
      transform: rotate(90deg);
    }

    @media (max-height: 390px) and (orientation: landscape) {
      .account:has(.account__login-slot[hidden]) .account__header {
        padding-block: 8px;
      }

      .account:has(.account__login-slot[hidden]) .account__content {
        padding-block-start: 4px;
        padding-block-end: 0;
        overflow-y: hidden;
      }

      .account:has(.account__login-slot[hidden]) .account__item {
        min-height: 44px;
        padding-block: 11.5px;
      }
    }

    @media (prefers-reduced-motion: reduce) {
      dialog.dialog,
      .account__close svg {
        animation: none !important;
        transition: none !important;
      }
    }
  `;

  const ensureShellStyles = (root, installation) => {
    if (!installation.style.isConnected) {
      root.append(installation.style);
    }
  };

  const installShell = (account) => {
    const root = account.shadowRoot;

    if (!root) {
      return false;
    }

    const existingInstallation = installedAccounts.get(account);

    if (existingInstallation?.root === root) {
      ensureShellStyles(root, existingInstallation);
      return true;
    }

    const style = document.createElement('style');
    style.dataset.pgAccountShell = '';
    style.textContent = shellStyles;
    const installation = { root, style };

    ensureShellStyles(root, installation);

    installation.observer = new MutationObserver(() => {
      queueMicrotask(() => {
        if (account.isConnected && account.shadowRoot === root) {
          ensureShellStyles(root, installation);
        }
      });
    });

    installation.observer.observe(root, {
      childList: true,
      subtree: true,
    });

    [50, 250, 1000, 3000].forEach((delay) => {
      setTimeout(() => {
        if (account.isConnected && account.shadowRoot === root) {
          ensureShellStyles(root, installation);
        }
      }, delay);
    });

    root.addEventListener(
      'click',
      (event) => {
        const closeButton = event.composedPath().find(
          (node) => node instanceof Element && node.classList.contains('account__close')
        );

        if (closeButton) {
          root.querySelector('dialog.dialog')?.classList.add('pg-account-closing');
        }
      },
      true
    );

    account.addEventListener(
      'click',
      (event) => {
        const accountButton = event.composedPath().find(
          (node) => node instanceof Element && node.classList.contains('account-button')
        );

        if (accountButton) {
          root.querySelector('dialog.dialog')?.classList.remove('pg-account-closing');
        }
      },
      true
    );

    installedAccounts.set(account, installation);
    return true;
  };

  let accountDiscoveryAttempts = 0;

  const initialize = () => {
    const account = document.querySelector('shopify-account.pg-shopify-account');

    if (!account) {
      if (accountDiscoveryAttempts < 200) {
        accountDiscoveryAttempts += 1;
        setTimeout(initialize, 50);
      }

      return;
    }

    accountDiscoveryAttempts = 0;

    let attempts = 0;

    const installWhenReady = () => {
      if (installShell(account) || attempts >= 120) {
        return;
      }

      attempts += 1;
      requestAnimationFrame(installWhenReady);
    };

    installWhenReady();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
